<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <self-sign-list slot-scope="{data}" :config="data.config" :reservation-name="data.reservationName"></self-sign-list>
  </l-cache>
</template>

<script>
import selfSignList from './selfSignList'

export default {
  name: 'selfSignListBox',
  components: {selfSignList},
  methods: {
    async getItem (key) {
      let data = {
        config: this.$route.params.config,
        reservationName: this.$route.query.name
      }
      return data
    }
  }
}
</script>

<style scoped>

</style>
